<div class="progress-container">
  <mat-progress-bar mode="determinate" value="25"></mat-progress-bar>
</div>

<!-- <div class="title-container">
        <h2>{{ 'calendar.title' | translate }}: {{event_name}}</h2>
    </div> -->
<div class="calendar">
  @if (oldMassiveSlot) {
    <div class="sub-title-container">
      <div class="card">
        <div class="header">
          <h3>{{ "calendar.card_title" | translate }}</h3>
        </div>
        <div class="content">
          <div class="info slot">
            <b class="light-bold">{{ "calendar.slot" | translate }}</b>
            {{ oldMassiveSlot.displayDateTime.replace(" -", "") }} -
            {{ oldMassiveSlot.occurrence_end_time }}
          </div>

          <div class="info posti">
            <div>
              <b class="light-bold">{{ "calendar.max_places" | translate }}</b>
              {{ oldMassiveSlot.max_users }}
            </div>
            <div>
              <b class="light-bold">{{
                  "calendar.current_reservation" | translate
                }}</b>
              {{ old_number_of_users }}
            </div>
            <div>
              <b class="light-bold">{{
                  "calendar.start_reservation_others" | translate
                }}</b>
              {{ oldMassiveSlot.max_users - oldMassiveSlot.available_users }}
            </div>
            <div>
              <b class="light-bold">{{
                  "calendar.free_reservation" | translate
                }}</b>
              {{ oldMassiveSlot.available_users - old_number_of_users! }}
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="flex-container">
    <div class="calendar-container">
      <mat-calendar
        [startAt]="selectedDate"
        [(selected)]="selectedDate"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [dateFilter]="dateFilter"
        (selectedChange)="handleDateSelection()"
      >
      </mat-calendar>
    </div>

    <div class="accordion-container">
      <mat-accordion multi>
        <mat-expansion-panel
          [disabled]="orari_mattino_disabled"
          [expanded]="isMattinoExpanded"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "calendar.morning" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (slot of orari_mattino; track slot.uuid_event_occurrence){
            <ng-container
              [ngTemplateOutlet]="timeButton"
              [ngTemplateOutletContext]="{ slot: slot }">
            </ng-container>
          }

        </mat-expansion-panel>

        <mat-expansion-panel
          [disabled]="orari_pomeriggio_disabled"
          [expanded]="isPomeriggioExpanded"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "calendar.afternoon" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for ( slot of orari_pomeriggio; track slot.uuid_event_occurrence) {
            <ng-container
              [ngTemplateOutlet]="timeButton"
              [ngTemplateOutletContext]="{ slot: slot }">
            </ng-container>
          }

        </mat-expansion-panel>

        <mat-expansion-panel
          [disabled]="orari_sera_disabled"
          [expanded]="isSeraExpanded"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "calendar.evening" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (slot of orari_sera; track slot.uuid_event_occurrence) {
            <ng-container
              [ngTemplateOutlet]="timeButton"
              [ngTemplateOutletContext]="{ slot: slot }">
            </ng-container>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div class="btn-container">
    <button
      class="my-button"
      (click)="goTo('profiles')"
      [disabled]="!isComplete"
    >
      {{ "proceed" | translate }}
    </button>
  </div>
</div>

<ng-template #closedSlotMessage>
  <div>
    <span>{{ "calendar.closed_slot" | translate }}</span>
  </div>
</ng-template>

<ng-template #timeButton let-slot="slot" >
  <button
    class="time-button"
    (click)="handleTimeSelection(slot)"
    [ngClass]="[
              !slot.available ? 'time-btn-disabled' : '',
              slot.selected ? 'selected' : ''
            ]"
    [disabled]="!slot.available"
  >
    {{ convertTime(slot.occurrence_start_time, userLanguage) }} -
    {{ convertTime(slot.occurrence_end_time, userLanguage) }}
    <br />
    {{ isSpaFlux() && slot.detail ? slot.detail : "" }}
    <br />
    @if ((slot.are_reservations_not_closed || slot.are_reservations_not_closed_wl) && slot.are_reservations_open) {
          @if (slot.are_reservations_not_closed) {
                <div>
                  <span>{{ "calendar.free_places" | translate }}:</span>
                  {{ slot.available_users }}/{{ slot.max_users }}
                  {{ "calendar.places" | translate }}
                </div>
          }
    } @else {
        <ng-container [ngTemplateOutlet]="closedSlotMessage"></ng-container>
    }
  </button>
</ng-template>
